import styled, { css } from 'styled-components'
import { layout, position } from 'styled-system'

const rotateAngleCss = ({ rotateAngle }) =>
  rotateAngle &&
  css`
    transform: rotateZ(${rotateAngle}deg);
  `

const shouldForwardProp = prop => {
  return !['rotateAngle'].includes(String(prop))
}

export const Container = styled.div.withConfig({
  shouldForwardProp,
})`
  position: absolute;

  ${layout}
  ${position}

  ${rotateAngleCss}
`
